import React, { useMemo, useState } from "react";
import SlideOutSidebar from "../../ui-components/slide-out-sidebar/slideOutSidebar";
import { LabelModes } from "../../ui-components/molecules/labeled-inputs/labeledInput";
import Button, { ButtonThemes } from "../../ui-components/button/button";
import LabeledSelectInput from "../../ui-components/molecules/labeled-inputs/labeled-select-input/labeledSelectInput";
import { debounce } from "lodash";
import DriverService from "../../app/data/drivers/driversService";
import { useSelector } from "react-redux";
import { linehaulMileageSelector } from "../../slices/linehaul-mileage/linehaulMileageSlice";

const driverService = DriverService.getInstance();

export interface SelectDriverProps {
  show: boolean;
  onDriverSelect: (driverId: string) => void;
  closeModal: any;
}

export const SelectDriver: React.FC<SelectDriverProps> = (props) => {
  const [driver, setDriver] = useState<string>();
  const linehaulMileageState = useSelector(linehaulMileageSelector);

  const loadDriverOptions = useMemo(
    () =>
      debounce((query: string, callback: (options: { value: string; label: string }[]) => void) => {
        const search = query.trim();
        if (search.length < 2) {
          callback([]);
          return;
        }

        driverService
          .getDrivers("", search, 0)
          .then((response) => {
            const items = response.data?.items ?? [];
            callback(
              items.map((item) => {
                const name = `${item.firstName ?? ""} ${item.lastName ?? ""}`.trim();
                return {
                  value: item.driverId,
                  label: `${name} (${item.driverId})`,
                };
              })
            );
          })
          .catch(() => callback([]));
      }, 300),
    []
  );

  return (
    <SlideOutSidebar size={"small"} header="Assign a Driver" show={props.show} onClose={props.closeModal}>
      <div className="xgs-lmi__title">Assign a Driver</div>
      <LabeledSelectInput
        label="Driver"
        labelMode={LabelModes.column}
        placeholder="Type at least 2 characters to search"
        isClearable
        async
        loadOptions={loadDriverOptions}
        options={[]}
        noOptionsMessage={({ inputValue }) =>
          inputValue.trim().length < 2
            ? "Type at least 2 characters to search"
            : "No drivers found"
        }
        onValueChange={(t) => setDriver(t?.value as any)}
        className="xgs-item-form__field"
      />
      <div className="xgs-lmi__driver-select__buttons">
        <Button onClick={props.closeModal} theme={ButtonThemes.gray}>Cancel</Button>
        <Button
          onClick={() => {
            props.onDriverSelect(driver!);
          }}
          disabled={!driver}
          spinner={linehaulMileageState.requestStarted}
          theme={ButtonThemes.blue}
        >
          Assign driver
        </Button>
      </div>
    </SlideOutSidebar>
  );
};
